import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { texts } from '../../utils/Localization.js';
import { fComp } from '../../utils/React.js';
import { LogoPresentation } from '../Logo/LogoPresentation.js';
import { hostClass } from './Brandbar.styles.js';

var defaultProps = {};
var BrandbarPresentation = fComp(function (props) {
  var _cleanupClassObject;
  var id = props.id,
    className = props.className,
    noMargin = props.noMargin,
    isStencilHost = props.isStencilHost,
    slogan = props.slogan,
    href = props.href,
    actionAs = props.actionAs,
    actionProps = props.actionProps,
    logoAlt = props.logoAlt,
    logoSrcCustom = props.logoSrcCustom,
    logoDisabled = props.logoDisabled,
    logoHtmlAttrs = props.logoHtmlAttrs,
    onLogoClick = props.onLogoClick;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement(LogoPresentation, {
    className: "".concat(hostClass, "-logo"),
    alt: logoAlt,
    isMonochrome: true,
    fitToBox: true,
    variant: "horizontal",
    href: href,
    onClick: onLogoClick,
    actionAs: actionAs,
    actionProps: actionProps,
    disabled: logoDisabled,
    srcCustom: logoSrcCustom,
    htmlAttrs: Object.assign({
      "aria-label": texts.lsg.component.Logo.actionHome
    }, logoHtmlAttrs)
  }), /*#__PURE__*/React.createElement("p", {
    className: "".concat(hostClass, "-claim")
  }, slogan));
}, defaultProps);
BrandbarPresentation.displayName = "BrandbarPresentation";

export { BrandbarPresentation, defaultProps };
